import React, { useState, useRef } from "react";
import { VerifyMobileOTPServices } from "../../services/index";

const MobileVerifyOtp = ({ setMobileverifyOtp }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);

  const mobile = localStorage.getItem("newmobilenumber");
  const newNumber = `******${mobile.slice(6)}`;
  const handleSubmit = (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (otpValue.length === 6) {
      VerifyAdharOtp(otpValue);
    } else {
      alert("Please enter a valid 4-digit OTP.");
    }
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const VerifyAdharOtp = async (otp) => {
    try {
      const body = {
        otpValue: otp,
        txnId: localStorage.getItem("txnId"),
      };
      const response = await VerifyMobileOTPServices({ body });
      if (response.status) {
        setMobileverifyOtp(true);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA Address and store all your medical records in one
                  place. Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA Address.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA address.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <h3>Verify Your Mobile OTP</h3>
                <p className="pt-3">
                  Please Enter The 6-Digit OTP Sent To The Aadhaar-Linked Mobile
                  Number. We Have Sent The OTP To The Mobile Number Ending In
                  {newNumber}, Which Is Linked With The Aadhaar Number.
                </p>
                <form onSubmit={handleSubmit} className="pt-3">
                  <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                    <div className="row">
                      {otp.map((digit, index) => (
                        <div
                          key={index}
                          className="col-ms-2 col-lg-2 col-xl-2 col-sm-2 col-xs-2"
                        >
                          <input
                            type="text"
                            maxLength="1"
                            placeholder="0"
                            value={digit}
                            ref={(el) => (inputRefs.current[index] = el)}
                            onChange={(e) => handleInputChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            className="mobile-input otp"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  <button type="submit" className="continue-btn">
                    Continue
                  </button>
                  <p className="pt-2">
                    Don't Receive ОТР To Your Number ?{" "}
                    <a className="resend-otp" href="#">
                      Resend ОТР
                    </a>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileVerifyOtp;
